
import {ShCompanySearch} from 'components/search-dropdown'

export default {
  components: {ShCompanySearch},
  emits: ['submit'],
  data() {
    return {
      first_name: '',
      first_name_valid: false,
      last_name: '',
      last_name_valid: false,
      middle_name: '',
      middle_name_valid: false,
      position: '',
      position_valid: false,
      linkedin_id: '',
      linkedin_id_valid: false,
      shared_company_id: undefined,
      loading: false,
    }
  },
  computed: {
    can_submit() {
      return this.first_name_valid && this.last_name_valid && this.middle_name_valid && this.linkedin_id_valid && this.position_valid 
    }
  },
  methods: {
    open(){
      this.first_name = undefined
      this.last_name = undefined
      this.middle_name = undefined
      this.position = undefined
      this.linkedin_id = undefined
      this.shared_company_id = undefined
      this.loading = false
      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.f_name.focus())
    },
    close(force) {
      if (!force && this.loading) return
      this.$refs.modal.close()
    },
    submit() {
      this.loading = true
      this.$emit('submit', {
        first_name: this.first_name,
        last_name: this.last_name,
        middle_name: this.middle_name,
        position: this.position,
        linkedin_id: this.linkedin_id,
        shared_company_id: this.shared_company_id
      })
    }
  }
}
